var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchlossAktiv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Schloss-Aktiv__Icn/40px/Schloss-Aktiv",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Schloss-Aktiv__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Schloss-Aktiv__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,8.32576539 C23.2513558,8.32576539 25.880801,11.0146334 25.9960596,14.3545212 L26,14.5832257 L26,17 C27.1045695,17 28,17.8954305 28,19 L28,29 C28,30.1045695 27.1045695,31 26,31 L14,31 C12.8954305,31 12,30.1045695 12,29 L12,19 C12,17.8954305 12.8954305,17 14,17 L14,14.5832257 C14,11.1382435 16.6747498,8.32576539 20,8.32576539 Z M20,21 C18.8954305,21 18,21.8954305 18,23 C18,23.7402524 18.4021661,24.3865739 18.9999275,24.7323937 L19,28 L21,28 L21.0010775,24.7318119 C21.5982846,24.3858493 22,23.7398375 22,23 C22,21.8954305 21.1045695,21 20,21 Z M20,10.3257654 C17.8689966,10.3257654 16.1095994,12.1078565 16.0049261,14.3698022 L16,14.5832257 L16,16.9997654 L24,16.9997654 L24,14.5832257 C24,12.2209776 22.1975973,10.3257654 20,10.3257654 Z",
    id: ".._.._src_svg_Icn_40px_Schloss-Aktiv__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchlossAktiv);
export default __webpack_public_path__ + "static/media/Schloss-Aktiv.3ae6e066ed4a912348b667147858421b.svg";
export { ForwardRef as ReactComponent };